import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box } from "@mui/material";
import { TableStructure } from "../../../../common/Interfaces";
import NoDataRowValues from "../../noData/NoDataRowValues";
import styles from './DataTable.module.scss';
import PaginationControl from "./PaginationControl";

export default function DataTable ({Headers, Rows, Pagination}: TableStructure){
    return (
        <Box>
            <TableContainer component={Paper}>
                <Table className={styles.tableMinWidth} size="small">
                    <TableHead>
                        <TableRow className={styles.titleRow}>
                            {Headers.map((header) => <TableCell className={styles.title}>{header}</TableCell>)}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Rows && Rows.length > 0 ? (
                            Rows.map((row => 
                                <TableRow 
                                    key={row.key}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    {row.values.map(value => 
                                        <TableCell className={styles.normalText}>
                                            <Box className= {styles.valueContainer}>
                                                {value}
                                            </Box>
                                        </TableCell>
                                    )}    
                                </TableRow>))
                        ):
                        (
                            <NoDataRowValues columnsCount={Headers.length} />
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {Pagination && (
                <PaginationControl 
                    rowsPerPage={Pagination.rowsPerPage} 
                    currentPage={Pagination.currentPage}
                    setCurrentPage={Pagination.setCurrentPage}
                    dataCount={Pagination.dataCount}/>
            )}
        </Box>
        
    );
}